import axios from 'axios'

/** i18next `t` funksiyasining bu yerda kerak bo'lgan qismi */
export type Translate = (key: string, options?: Record<string, unknown>) => string

/**
 * Xato tanasi endi HAR DOIM envelope
 * (`uz.xsib.common.response.XsibResponse`): matn `error.text` da.
 *
 * ⚠️ Spring Security'ning o'z 401/403 javobi ham shu shaklda —
 * `XsibSecurityErrorHandler` uni ham envelope qilib yozadi. Ilgari u
 * yagona istisno edi va aynan shu tufayli bu yerda ikkita maydon
 * o'qilardi.
 *
 * Eski maydonlar (`detail`, `message`) ATAYLAB qoldirildi: zanjirda
 * backend'dan boshqa manbalar ham bor (nginx, proksi), va ularsiz
 * xabar "xato bor, sababi noma'lum" bo'lib qolardi.
 */
interface ApiErrorBody {
  error?: { code?: number; tag?: string; text?: string } | null
  detail?: string
  message?: string
  title?: string
}

/**
 * Javobdagi MASHINA o'qiydigan belgi — `XsibResponse.error.tag`
 * (`INSUFFICIENT_FUNDS`, `PLAN_NOT_AVAILABLE` va h.k.).
 *
 * `null` — javob envelope emas yoki belgisi yo'q: tarmoq uzilgan, nginx
 * yoki proksi javob bergan, xato umuman HTTP dan kelmagan.
 *
 * ⚠️ BELGI EKRANGA CHIQMAYDI. U faqat panelning O'ZI uchun: qaysi
 * matnni ko'rsatish va qanday chiqish yo'lini taklif qilishni hal
 * qilish uchun. Abonentga `INSUFFICIENT_FUNDS` degan so'z hech qanday
 * ma'no bermaydi.
 */
export function errorTag(error: unknown): string | null {
  if (!axios.isAxiosError<ApiErrorBody>(error)) return null
  const tag = error.response?.data?.error?.tag
  const trimmed = tag?.trim().toUpperCase()
  return trimmed ? trimmed : null
}

/**
 * Bu — TIZIM NOSOZLIGI EMAS, ANIQ RAD JAVOBI: hisobda pul yetmadi.
 *
 * <h2>⚠️ Nega ikkalasini ajratish shart</h2>
 * Ikkalasiga bir xil muomala qilinganda ekranda "qayta urining" chiqadi
 * va bu holatda maslahat ZARARLI: balans o'zgarmagan, ya'ni qayta
 * urinish AYNAN shunday rad etiladi. Abonent tugmani bosaverib tizim
 * buzuq degan xulosaga keladi, haqiqiy chiqish yo'li (balansni
 * to'ldirish) esa hech qayerda aytilmaydi.
 *
 * Manba: `SelfcareExceptionHandler.insufficientFunds` — 422 va
 * `tag = "INSUFFICIENT_FUNDS"` (`XsibResponse` javadoc'i: "panel javobni
 * aynan `tag` bo'yicha tarjima qiladi").
 *
 * ⚠️ Serverning MATNI bu holatda ishlatilmaydi va buning aniq sababi
 * bor: u "Kerak: 5000000, mavjud: 1200000" deb yozadi, ya'ni MINOR
 * birlikdagi xom sonlarni valyutasiz. Abonent 5 000 000 so'm kerak deb
 * o'qiydi, aslida 50 000. Ustiga u faqat o'zbekcha.
 */
export function isInsufficientFunds(error: unknown): boolean {
  return errorTag(error) === 'INSUFFICIENT_FUNDS'
}

/**
 * Backend xatosini abonentga ko'rsatiladigan, tarjima qilingan matnga
 * aylantiradi.
 *
 * Backend matn yuborsa — o'shani ko'rsatamiz (server domen qoidasini bizdan
 * yaxshiroq biladi, masalan "Balansda mablag' yetarli emas"). Aks holda
 * HTTP holatiga qarab umumiy xabar tanlanadi.
 */
export function translateError(error: unknown, t: Translate): string {
  if (axios.isAxiosError<ApiErrorBody>(error)) {
    const body = error.response?.data
    const serverText = body?.error?.text ?? body?.detail ?? body?.message
    if (serverText) return serverText

    if (!error.response) return t('errors.network')
    const status = error.response.status

    if (status === 401) return t('errors.serverRejected')
    if (status === 403) return t('errors.forbidden')
    if (status === 404) return t('errors.notFound')
    if (status === 409) return t('errors.conflict')
    if (status === 422) return t('errors.unprocessable')
    return t('errors.withCode', { status })
  }
  if (error instanceof Error && error.message) return error.message
  return t('errors.generic')
}
